import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Box,
  Paper,
} from "@mui/material";

const categories = [
  "Board of Directors",
  "Key Management Personnel",
  "Employees other than BoD and KMPs",
  "Workers",
];

const TableField = ({ data, handleInputChange, error, disabled }) => {
  const handleNumericChange = (key, field, value) => {
    // Allow empty value for editing and only numeric input with optional decimal.
    if (!/^\d*\.?\d*$/.test(value)) return;
    handleInputChange(key, field, value);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ mb: 3, borderRadius: "10px", width: "99%", marginLeft: "0.9rem" }}
      >
        <Table sx={{ border: "1px solid #ddd" }} size="small">
          <TableHead>
            <TableRow>
              <TableCell
                rowSpan={2}
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid white",
                }}
              >
                Category
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid white",
                }}
              >
                Males
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                Females
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid white",
                }}
              >
                No. of Male
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid white",
                }}
              >
                Median remuneration/ salary/wages of respective category
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                  borderRight: "1px solid white",
                }}
              >
                No. of Female
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                Median remuneration/ salary/wages of respective category
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((category, index) => {
              const key = Object.keys(data)[index];
              const values = data[key];

              return (
                <TableRow key={key}>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {category}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <TextField
                      size="small"
                      disabled={disabled}
                      error={!!error[`${key}_numberofmale`]}
                      value={values.numberofmale}
                      onChange={(e) =>
                        handleNumericChange(key, "numberofmale", e.target.value)
                      }
                      variant="standard"
                      placeholder="Enter Number"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                        },
                      }}
                      // sx={{
                      //   width: "100%",
                      //   "& .MuiInputBase-input": {
                      //     borderBottom: error[`${key}_numberofmale`] ? "2px solid #d32f2f" : "none",
                      //   },
                      // }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <TextField
                      size="small"
                      disabled={disabled}
                      error={!!error[`${key}_maleWages`]}
                      value={values.maleWages}
                      onChange={(e) =>
                        handleNumericChange(key, "maleWages", e.target.value)
                      }
                      variant="standard"
                      placeholder="Enter Amount"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                        },
                      }}
                      sx={{
                        width: "100%",
                        // "& .MuiInputBase-input": {
                        //   borderBottom: error[`${key}_maleWages`] ? "2px solid #d32f2f" : "none",
                        // },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <TextField
                      size="small"
                      disabled={disabled}
                      error={!!error[`${key}_numberofFemale`]}
                      value={values.numberofFemale}
                      onChange={(e) =>
                        handleNumericChange(key, "numberofFemale", e.target.value)
                      }
                      variant="standard"
                      placeholder="Enter Number"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                        },
                      }}
                      sx={{
                        width: "100%",
                        // "& .MuiInputBase-input": {
                        //   borderBottom: error[`${key}_numberofFemale`] ? "2px solid #d32f2f" : "none",
                        // },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <TextField
                      disabled={disabled}
                      size="small"
                      error={!!error[`${key}_femaleWages`]}
                      value={values.femaleWages}
                      onChange={(e) =>
                        handleNumericChange(key, "femaleWages", e.target.value)
                      }
                      variant="standard"
                      placeholder="Enter Amount"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                        },
                      }}
                      sx={{
                        width: "100%",
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ marginTop: "-1rem", marginLeft: "0.9rem" }}>
        {Object.entries(error).map(([field, errorMessage]) => (
          // <Typography key={field} variant="body2">
          <span
            key={field}
            color="error"
            style={{
              lineHeight: "1.2",
              margin: "-2rem 0.5rem 0rem 0rem",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {field}: {errorMessage}
          </span>
        ))}
      </Box>
    </>
  );
};

export default TableField;
